import { ChangeEvent, Dispatch, SetStateAction } from "react";

const updateFilters =
	(setter: Dispatch<SetStateAction<string[]>>) =>
	({ target }: ChangeEvent<HTMLInputElement>) =>
		setter((prev) => prev.filter((e) => e !== target.name).concat(target.checked ? [target.name as string] : []));

export default function Filter({
	name,
	options,
	filters,
	setFilters,
	disabled = [],
}: {
	name: string;
	options: { [key: string]: string };
	filters: string[];
	setFilters: Dispatch<SetStateAction<string[]>>;
	disabled?: string[];
}) {
	return (
		<fieldset>
			<legend className="block font-medium">
				{name}
				{filters.length !== 0 && (
					<>
						{" "}
						—{" "}
						<button
							className="font-bold text-cary-400 hover:underline"
							onClick={() => {
								setFilters([]);
							}}>
							Reset
						</button>
					</>
				)}
			</legend>
			<div className="inline-block space-y-6 pt-6 sm:space-y-4 sm:pt-4">
				{Object.entries(options).map(([text, value]) => (
					<div
						key={text}
						className={`flex items-center text-base sm:text-sm ${
							disabled.includes(value) ? "cursor-not-allowed" : ""
						}`}>
						<input
							id={`filter-${text}`}
							name={value}
							checked={filters.includes(value)}
							onChange={updateFilters(setFilters)}
							type="checkbox"
							disabled={disabled.includes(value)}
							className="h-4 w-4 flex-shrink-0 rounded border-gray-300 text-cary-400 focus:ring-cary-300 disabled:cursor-not-allowed disabled:bg-gray-100"
						/>
						<label
							htmlFor={`filter-${text}`}
							className={`ml-3 min-w-0 flex-1 ${
								disabled.includes(value) ? "cursor-not-allowed text-gray-400" : "text-gray-600"
							}`}>
							{text}
						</label>
					</div>
				))}
			</div>
		</fieldset>
	);
}
